export default __webpack_public_path__ + "static/media/img1.53741a84.jpeg";